<template>
  <div class="ll-quiz-question-edit">
    <div class="ll-quiz-question-edit-left">
      <WsTitle001
        v-if="index"
        h4
        class="mt-20 ml-28"
        style="flex: 0 0 auto"
      >
        {{ index }}.
      </WsTitle001>
      <WsCol class="ml-6">
        <WsCol>
          <WsTitle001
            :h4="content?false:true"
            :h5="content?true:false"
            :bold="content?true:false"
          >
            {{ $t(title) }}
          </WsTitle001>
          <WsText001
            v-if="content"
            class="mt-8"
            style="white-space: pre-line"
          >
            {{ $t(content) }}
          </WsText001>
        </WsCol>
        <WsCol>
          <WsTextButton001
            v-if="hasPopupContent"
            primary
            bold
            no-padding
            class="mt-20"
            leading-icon="icon-info"
            @click="$_popupOpen()"
          >
            {{ $t(popupBtnText) }}
          </WsTextButton001>
        </WsCol>
        <WsCol>
          <WsTextChip001
            v-if="updateVersion"
            class="mt-20"
            red
            icon-lg
            :text-label="updateVersionLabel"
            leading-icon="icon-info"
          />
        </WsCol>
        <WsStateHideInputError
          :value="value"
          :errorMessages="$t('此題目必答')"
          :rules="quizAnswerRequired"
        />
      </WsCol>
    </div>
    <div class="ll-quiz-question-edit-right">
      <LlBtnGroups
        btn-small-size
        :two-item="btnList.length===2"
        :textarea-default-show="textareaDefaultShow"
        :attaches-default-show="attachesDefaultShow"
        is-full
        :value="value"
        :btn-list="btnList"
        :uploadAttaches="uploadAttaches"
        :textarea-place-holder="textareaPlaceholder"
        :textarea-content="textareaContent"
        :textarea-title="textareaTitle"
        :file-btn-title="fileBtnTitle"
        :textarea-rules="textareaRules"
        :attaches-rules="attachesRules"
        :avatarDropdown="avatarDropdown"
        :uploadModule="uploadModule"
        @update-attach="$emit('update-attach', $event)"
        @input="btnClick($event)"
        @reset-textarea="resetTextArea($event)"
        @change-textarea-vlue="$_changeTextareaValue($event)"
        @click-avatar="$emit('click-avatar', $event)"
      />
    </div>
    <slot name="popup">
      <PopUp
        :title="popupTitle"
        :popUpActive="popupActive && hasPopupContent"
        @click="$_popupClose()"
      >
        <WsText001
          v-if="popupContent"
          h4
          class="mt-10"
        >
          {{ $t(popupContent) }}
        </WsText001>
        <div
          v-for="(subClass, subClass_k) in riskListBySubClasses"
          :key="`s-${subClass_k}`"
        >
          <WsText001
            h4
            bold
            class="mt-20"
          >
            {{ $t('風險評估項目') }}-{{ $t(subClass.subclassName) }}
          </WsText001>
          <ul
            style="list-style: disc;"
            class="pl-20"
          >
            <div
              v-for="(riskItem, riskItem_k) in subClass.riskList"
              :key="`r-${riskItem_k}`"
              class="mt-10"
            >
              <li>
                <WsText001 h4>
                  {{ $t(riskItem.name) }}
                </WsText001>
              </li>
            </div>
          </ul>
        </div>
      </PopUp>
    </slot>
  </div>
</template>
<script>
export default {
  name: "LlQuizQuestionEdit",
  props: {
    textareaPlaceholder: {
      type: String,
      default() {
        return this.$t("輸入");
      },
    },
    quizAnswerRequired: {
      type: String,
      default: "required",
    },
    attachesRules: {
      type: String,
      default: "",
    },
    textareaRules: {
      type: String,
      default: "",
    },
    textareaDefaultShow: {
      type: Boolean,
      default: false,
    },
    attachesDefaultShow: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: "",
    },
    isFull: {
      type: Boolean,
      default: false,
    },
    updateVersion: {
      type: Boolean,
      default: false,
    },
    updateVersionLabel: {
      type: String,
      default: "",
    },
    index: {
      type: String,
      default: "",
    },
    hasPopupContent: {
      type: Boolean,
      default: false,
    },
    textareaContent: {
      type: String,
      default: "",
    },
    popupContent: {
      type: String,
    },
    popupTitle: {
      type: String,
      default: "popupTitlepopupTitlepopupTitle",
    },
    textareaTitle: {
      type: String,
      default() {
        return this.$t("敘述");
      },
    },
    fileBtnTitle: {
      type: String,
      default() {
        return this.$t("附件");
      },
    },
    popupBtnText: {
      type: String,
      default() {
        return '查看說明';
      },
    },
    title: {
      type: String,
      default: "",
    },
    uploadAttaches: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Number,
      default: null,
    },
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
    riskListBySubClasses: {
      type: Array,
      default() {
        return [];
      },
    },
    avatarDropdown: {
      type: Object,
    },
    uploadModule: {
      type: String,
    }
  },
  data: () => ({
    popupActive: false,
  }),
  methods: {
    btnClick($event) {
      this.$emit("input", $event);
    },
    resetTextArea($event) {
      this.$emit("reset-textarea", $event);
    },
    $_popupOpen() {
      this.$emit('open-popup');
      this.popupActive = true;
    },
    $_popupClose() {
      this.popupActive = false;
    },
    $_changeTextareaValue(e) {
      this.$emit("change-textarea-vlue", e);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-quiz-question-edit";
</style>